import React from 'react'
import './AssetDetailsV2Fields.css'
import { fieldMapper } from './helper'

const AssetDetailsV2Fields: React.FC = (props: any) => {
  const { fieldSchema, keyName, mode = "edit" } = props
  const boundaryRef = React.useRef<HTMLDivElement>(null)
  return (
    <div className='asset-details-v2-fields-container'>
      {fieldSchema.map((field, index) => (
        <div key={index} className={field?.className || ''}>
          {fieldMapper(field, boundaryRef, "large", keyName, mode)}
          {index !== fieldSchema.length - 1 && <div className={`mt-30 asset-details-v2-fields-container__field-divider ${field?.enableAiSuggestion ? 'asset-details-v2-fields-container__field-divider--ai-suggested' : ''}`} />}
        </div>
      ))}
    </div>
  )
}
export default AssetDetailsV2Fields

AssetDetailsV2Fields.displayName = 'AssetDetailsV2Fields'